import React from 'react';
import {Badge, Container, Card, ListGroup} from "react-bootstrap";
import config from "../../config";


const Schedule = () => {
    return (
        <Container>
            <h2 className="pt-4 title">Schedule</h2>
            <div className="row">
                {/*<p className="d-flex justify-content-center align-items-center text-success fw-bold" >To Be Announced (TBA)</p>*/}
                <div className="col-md-9 m-auto">
                    <Card>
                   <Card.Body>
                       <ul style={{listStyle: 'none'}}>
                           <li > <h5 className="animated-text mb-3">New Updated Program Schedule:   <a href="/template/ProgramSchedule2025Updated.pdf"  target="_blank">Click Here</a></h5></li>
                       </ul>

                        <iframe
                            src="/template/ProgramSchedule2025Updated.pdf"
                            width="100%"
                            height="400px"
                            style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                            title="Program Schedule PDF"
                        />
                       <h5 className="animated-text mb-3">Transport Schedule:   <a href="/template/TransportSchedule2025.pdf"  target="_blank">Click Here</a></h5>
                       <iframe
                            src="/template/TransportSchedule2025.pdf"
                            width="100%"
                            height="400px"
                            style={{ border: '1px solid #ccc', borderRadius: '8px' }}
                            title="Program Schedule PDF"
                        />

                   </Card.Body>
               </Card>
                </div>


            </div>
        </Container>
    )
}

export default Schedule;